import React from 'react';
import styles from './Market.module.scss';
import ResultType from './ResultType/ResultType';
import Outcomes from './Outcomes/Outcomes';
import { useSelector } from 'react-redux';
import { findName, formatSpecifierName, formatTeamNames } from '../../../../../utils/render';
import { RESULT_TYPE_WITH_SPECIFIER } from '../../../../../constants/defaultValues';

const Market = props => {
    const { market, resultType, teams, tournamentName, playerNames } = props;

    const locale = useSelector(state => state.settings.locale);
    const descriptions = useSelector(state => state.descriptions.data);

    return (
        <div className={styles.market}>
            {resultType.name !== RESULT_TYPE_WITH_SPECIFIER ? (
                <ResultType name={resultType.name} />
            ) : null}
            {market.map(marketItem => {
                let marketName = '';

                if (resultType.name === RESULT_TYPE_WITH_SPECIFIER) {
                    if (marketItem.dynamic) {
                        marketName = findName(marketItem.names, locale);
                    } else {
                        if (marketItem.names && marketItem.outcomeNames) {
                            marketName = findName(marketItem.names, locale);
                        } else {
                            marketName = findName(
                                descriptions.markets[marketItem.marketRefId]?.names,
                                locale,
                            );
                        }
                    }
                }

                return (
                    <div key={marketItem.id}>
                        {resultType.name === RESULT_TYPE_WITH_SPECIFIER ? (
                            <ResultType
                                name={formatSpecifierName({
                                    name: marketName,
                                    specifiers: marketItem.specifiers,
                                    teams: formatTeamNames(teams, locale),
                                    tournamentName,
                                    playerNames,
                                })}
                            />
                        ) : null}
                        <Outcomes
                            market={marketItem}
                            teams={teams}
                            tournamentName={tournamentName}
                        />
                    </div>
                );
            })}
        </div>
    );
};

export default Market;
